(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  document.documentElement.style.setProperty('--header-height', `${document.querySelector('.section-header').offsetHeight}px`);
      
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Close sibling details panels when one opens
  const detailsList = document.querySelectorAll("details.mega-menu-top");
  const registerList = document.querySelectorAll("details.register");
  const productList = document.querySelectorAll("details.product-details");
  
  function handleDetailToggle(event) {
    if (!event.target.open) return;
    for (let details of detailsList) { details.open = details === event.target; }
    for (let details of registerList) { details.open = details === event.target; }
    for (let details of productList) { details.open = details === event.target; }
  }
  
  for (let details of detailsList) { details.addEventListener("toggle", handleDetailToggle); }
  for (let details of registerList) { details.addEventListener("toggle", handleDetailToggle); }
  for (let details of productList) { details.addEventListener("toggle", handleDetailToggle); }


  // ============================================================
  // Mega menu: open on hover (pointer devices only)
  // Keyboard / click / Escape / focus-out all work as expected
  // ============================================================
  class MegaMenuHover {
    constructor() {
      this.openDelay  = 100;
      this.closeDelay = 150;
      this.timers = new WeakMap();

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.init();
      }
    }

    init() {
      document.querySelectorAll('.mega-menu-parent').forEach(details => {
        const summary = details.querySelector('summary');

        if (summary) {
          summary.addEventListener('click', (event) => {
            const url = summary.dataset.url;
            if (!url || url === '#') return;
            if (event.detail === 0) return; // keyboard — keep toggle behavior

            event.preventDefault(); // stop the <details> from toggling closed
            window.location.href = url;
          });
        }

        // Open on mouseenter
        details.addEventListener('mouseenter', () => {
          clearTimeout(this.timers.get(details)?.close);
          const open = setTimeout(() => {
            details.setAttribute('open', '');
            summary?.setAttribute('aria-expanded', 'true');
          }, this.openDelay);
          this.timers.set(details, { ...this.timers.get(details), open });
        });

        // Close on mouseleave — unless keyboard focus is still inside
        details.addEventListener('mouseleave', () => {
          clearTimeout(this.timers.get(details)?.open);
          const close = setTimeout(() => {
            if (!details.contains(document.activeElement)) {
              details.removeAttribute('open');
              summary?.setAttribute('aria-expanded', 'false');
            }
          }, this.closeDelay);
          this.timers.set(details, { ...this.timers.get(details), close });
        });

        // Close when focus leaves the entire details element
        details.addEventListener('focusout', (e) => {
          if (!details.contains(e.relatedTarget)) {
            clearTimeout(this.timers.get(details)?.open);
            details.removeAttribute('open');
            summary?.setAttribute('aria-expanded', 'false');
          }
        });

        // Escape closes and returns focus to summary
        details.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && details.hasAttribute('open')) {
            details.removeAttribute('open');
            summary?.focus();
          }
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new MegaMenuHover());
  } else {
    new MegaMenuHover();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  var endlessScroll = null;
  var paginationObserver = null;

  function initAjaxinate() {
    // Destroy stale instance & remove its orphaned scroll listeners
    if (endlessScroll) {
      try { endlessScroll.destroy(); } catch (e) {}
      endlessScroll = null;
    }

    endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      productCard: '.product-card-wrapper',
      method: 'scroll',
      offset: 1000,
      saveHistory: true,
      scrollHistory: true,
      loader: true,
      overlayColor: '#faf9f7'  // ← match your page background
    });

    // Chunks can now be smaller (or empty, if a whole page was sold out).
    // When a chunk adds little or nothing, the "Loading More" link may already
    // be in view, and Ajaxinate only checks on scroll — so re-check after each
    // load to keep it from stalling.
    if (paginationObserver) paginationObserver.disconnect();
    var paginationEl = document.getElementById('AjaxinatePagination');
    if (paginationEl) {
      paginationObserver = new MutationObserver(function () {
        requestAnimationFrame(function () {
          document.dispatchEvent(new Event('scroll', { bubbles: true }));
        });
      });
      paginationObserver.observe(paginationEl, { childList: true });
    }
  }

  // Hook into FacetFiltersForm: reinitialize Ajaxinate every time
  // facet filtering replaces the product grid DOM
  var originalRender = FacetFiltersForm.renderProductGridContainer;
  FacetFiltersForm.renderProductGridContainer = function (html) {
    originalRender(html);   // runs the normal DOM replacement
    initAjaxinate();        // then gives Ajaxinate fresh element refs
  };

  initAjaxinate();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-blog"]) return;
  try {
    
    
    document.addEventListener('keydown', function (e) {
      
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        const childNext = document.querySelectorAll('.modal.show .next');
        const childPrev = document.querySelectorAll('.modal.show .prev');
    
        if (e.key === 'ArrowRight' & childNext.length) {
          childNext[0].click();
        } else if (e.key === 'ArrowLeft' & childPrev.length) {
          childPrev[0].click();
        }
      }
    });
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-page"] && !Shopify.designMode) return;
  try {
    
    
    document.addEventListener('keydown', function (e) {
      
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        const childNext = document.querySelectorAll('.modal.show .next');
        const childPrev = document.querySelectorAll('.modal.show .prev');
    
        if (e.key === 'ArrowRight' & childNext.length) {
          childNext[0].click();
        } else if (e.key === 'ArrowLeft' & childPrev.length) {
          childPrev[0].click();
        }
      }
    });
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio"]) return;
  try {
    
    
    document.addEventListener('keydown', function (e) {
      
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        const childNext = document.querySelectorAll('.modal.show .next');
        const childPrev = document.querySelectorAll('.modal.show .prev');
    
        if (e.key === 'ArrowRight' & childNext.length) {
          childNext[0].click();
        } else if (e.key === 'ArrowLeft' & childPrev.length) {
          childPrev[0].click();
        }
      }
    });
      

  } catch(e) { console.error(e); }
})();
})();
